/**
 * 백테스팅 상태 및 로직 관리 훅
 */
import { useState, useEffect } from 'react';
import {
  runBacktest,
  compareStrategies,
  getAvailableStrategies,
  BacktestResult,
  ComparisonResponse,
  StrategyInfo,
} from '../services/backtestApi';

export function useBacktest() {
  // 폼 상태
  const [symbol, setSymbol] = useState('AAPL');
  const [strategy, setStrategy] = useState('MA');
  const [period, setPeriod] = useState<'3M' | '6M' | '1Y'>('6M');
  const [initialCapital, setInitialCapital] = useState(10000);

  // 전략 목록
  const [strategies, setStrategies] = useState<StrategyInfo[]>([]);

  // 결과 상태
  const [backtestResult, setBacktestResult] = useState<BacktestResult | null>(
    null
  );
  const [comparisonResult, setComparisonResult] =
    useState<ComparisonResponse | null>(null);

  // UI 상태
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [activeTab, setActiveTab] =
    useState<'single' | 'comparison'>('single');

  // 전략 목록 로드
  useEffect(() => {
    loadStrategies();
  }, []);

  async function loadStrategies() {
    try {
      const data = await getAvailableStrategies();
      setStrategies(data);
    } catch (err: any) {
      console.error('전략 목록 조회 실패:', err);
    }
  }

  // 단일 백테스트 실행
  async function handleRunBacktest() {
    setLoading(true);
    setError(null);

    try {
      // 기간 계산
      const endDate = new Date();
      const startDate = new Date(endDate);
      if (period === '3M') startDate.setMonth(endDate.getMonth() - 3);
      else if (period === '6M') startDate.setMonth(endDate.getMonth() - 6);
      else startDate.setFullYear(endDate.getFullYear() - 1);

      const result = await runBacktest({
        symbol,
        strategy,
        start_date: startDate.toISOString().split('T')[0],
        end_date: endDate.toISOString().split('T')[0],
        initial_capital: initialCapital,
      });

      setBacktestResult(result);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  // 전략 비교 실행
  async function handleCompareStrategies() {
    setLoading(true);
    setError(null);

    try {
      const result = await compareStrategies(symbol, period);
      setComparisonResult(result);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return {
    // 폼 상태
    symbol,
    setSymbol,
    strategy,
    setStrategy,
    period,
    setPeriod,
    initialCapital,
    setInitialCapital,
    // 전략 목록
    strategies,
    // 결과 상태
    backtestResult,
    comparisonResult,
    // UI 상태
    loading,
    error,
    activeTab,
    setActiveTab,
    // 핸들러
    handleRunBacktest,
    handleCompareStrategies,
  };
}
